module.exports = __webpack_public_path__ + "static/media/maf-13.6ed196b8.png";